/**
 * I 13 ambiti di ricerca — elenco fornito dal Centro (contenuto autentico).
 * La glossa inglese è provvisoria: la traduzione definitiva è a cura del Centro.
 */
export interface Discipline {
  n: number;
  it: string;
  en: string | null;
}

export const disciplines: Discipline[] = [
  { n: 1, it: "Pedagogia Generale", en: "General Pedagogy" },
  { n: 2, it: "Epistemologia pedagogica", en: "Pedagogical Epistemology" },
  { n: 3, it: "Filosofia dell'Educazione", en: "Philosophy of Education" },
  { n: 4, it: "Filosofia della Formazione", en: "Philosophy of Formation" },
  { n: 5, it: "Bildungsphilosophie", en: "Philosophy of Bildung" },
  { n: 6, it: "Pedagogia Clinica", en: "Clinical Pedagogy" },
  { n: 7, it: "Pedagogia Sociale", en: "Social Pedagogy" },
  { n: 8, it: "Pedagogie Comparate", en: "Comparative Pedagogies" },
  { n: 9, it: "Pedagogia della Musica", en: "Pedagogy of Music" },
  { n: 10, it: "Semiotica dell'Educazione", en: "Semiotics of Education" },
  { n: 11, it: "Didattica Generale", en: "General Didactics" },
  { n: 12, it: "Didattica dei linguaggi visivi, artistici, estetici", en: "Didactics of Visual, Artistic and Aesthetic Languages" },
  { n: 13, it: "Figura e opera di don Lorenzo Milani", en: "The Life and Work of Don Lorenzo Milani" },
];
